var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _rect2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_70)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_70)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.5,
    filter: "url(#filter1_f_0_70)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2245 30.4201C24.3026 29.7732 24.568 29.411 25.068 29.0396C25.7834 28.5367 26.6771 28.8212 26.6771 28.8212V27.1336C26.8944 27.1281 27.1117 27.141 27.3266 27.1721V29.3439C27.3266 29.3439 26.4332 29.0594 25.7178 29.5626C25.218 29.9336 24.9521 30.2961 24.8743 30.943C24.8718 31.2943 24.9378 31.7535 25.2413 32.1506C25.1663 32.1121 25.0898 32.0683 25.0118 32.019C24.3431 31.57 24.2212 30.8962 24.2245 30.4201ZM31.0166 24.0133C30.5245 23.474 30.3383 22.9295 30.2711 22.547H30.8902C30.8902 22.547 30.7667 23.5499 31.6664 24.5362L31.6789 24.5495C31.4364 24.397 31.214 24.2169 31.0166 24.0133ZM33.999 25.5423V27.6703C33.999 27.6703 33.209 27.6394 32.6243 27.4906C31.808 27.2826 31.2833 26.9636 31.2833 26.9636C31.2833 26.9636 30.9208 26.736 30.8915 26.7202V31.1147C30.8915 31.3593 30.8245 31.9704 30.6202 32.4801C30.3535 33.1468 29.942 33.5844 29.8663 33.6739C29.8663 33.6739 29.3657 34.2654 28.4826 34.6638C27.6866 35.0231 26.9877 35.014 26.7788 35.0231C26.7788 35.0231 25.5707 35.071 24.4836 34.3645C24.2485 34.2088 24.0291 34.0324 23.8281 33.8377L23.8336 33.8416C24.9209 34.5481 26.1288 34.5002 26.1288 34.5002C26.338 34.4911 27.0368 34.5002 27.8326 34.1409C28.7149 33.7425 29.2162 33.1509 29.2162 33.1509C29.2911 33.0615 29.7046 32.6239 29.9702 31.9569C30.1739 31.4475 30.2415 30.8362 30.2415 30.5915V26.1975C30.2708 26.2137 30.633 26.4412 30.633 26.4412C30.633 26.4412 31.158 26.7605 31.9743 26.9683C32.5592 27.117 33.349 27.1479 33.349 27.1479V25.4804C33.6192 25.541 33.8496 25.5573 33.999 25.5423Z",
    fill: "#EE1D52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3502 25.4804V27.1474C33.3502 27.1474 32.5604 27.1165 31.9755 26.9677C31.1592 26.7597 30.6342 26.4407 30.6342 26.4407C30.6342 26.4407 30.272 26.2131 30.2427 26.197V30.592C30.2427 30.8367 30.1757 31.448 29.9714 31.9574C29.7047 32.6244 29.2931 33.062 29.2174 33.1515C29.2174 33.1515 28.7166 33.743 27.8338 34.1414C27.0381 34.5007 26.3392 34.4916 26.13 34.5007C26.13 34.5007 24.9222 34.5486 23.8348 33.8421L23.8293 33.8382C23.7145 33.727 23.6065 33.6096 23.5057 33.4866C23.1587 33.0636 22.946 32.5633 22.8925 32.4205C22.8924 32.4199 22.8924 32.4193 22.8925 32.4187C22.8065 32.1706 22.6258 31.5749 22.6505 30.9979C22.6942 29.9799 23.0523 29.355 23.147 29.1985C23.3978 28.7716 23.7239 28.3897 24.111 28.0697C24.4525 27.7936 24.8396 27.5739 25.2564 27.4197C25.707 27.2385 26.1895 27.1415 26.678 27.1336V28.8212C26.678 28.8212 25.7844 28.5378 25.0692 29.0396C24.5692 29.411 24.3038 29.7732 24.2257 30.4201C24.2225 30.8962 24.3443 31.57 25.0125 32.0193C25.0904 32.0687 25.167 32.1126 25.242 32.1509C25.3588 32.3026 25.5008 32.4348 25.6625 32.5422C26.3153 32.9554 26.8622 32.9843 27.5617 32.7159C28.028 32.5365 28.3791 32.1321 28.5419 31.6841C28.6442 31.4043 28.6428 31.1227 28.6428 30.8315V22.547H30.2706C30.3379 22.9295 30.524 23.474 31.0162 24.0133C31.2136 24.2169 31.436 24.397 31.6784 24.5495C31.7501 24.6236 32.1163 24.99 32.5865 25.2149C32.8296 25.3311 33.0859 25.4202 33.3502 25.4804Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2441 31.9023V31.9036L22.2845 32.0131C22.2799 32.0004 22.2649 31.9616 22.2441 31.9023Z",
    fill: "#69C9D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2564 27.4196C24.8396 27.5739 24.4525 27.7936 24.111 28.0697C23.7238 28.3904 23.3977 28.7731 23.1473 29.2008C23.0526 29.3568 22.6945 29.9822 22.6508 31.0002C22.6261 31.5772 22.8068 32.1729 22.8928 32.421C22.8927 32.4216 22.8927 32.4222 22.8928 32.4228C22.9471 32.5643 23.159 33.0646 23.506 33.4889C23.6067 33.612 23.7148 33.7293 23.8296 33.8405C23.4618 33.5967 23.1337 33.3019 22.8562 32.9658C22.5122 32.5463 22.3 32.0512 22.2447 31.9051C22.2446 31.9041 22.2446 31.903 22.2447 31.902V31.9002C22.1584 31.6524 21.9772 31.0564 22.0024 30.4786C22.0461 29.4606 22.4042 28.8357 22.4989 28.6792C22.7493 28.2515 23.0753 27.8687 23.4625 27.5481C23.804 27.2719 24.1911 27.0522 24.608 26.898C24.868 26.7946 25.1389 26.7183 25.4159 26.6705C25.8335 26.6006 26.2599 26.5946 26.6794 26.6525V27.1336C26.1904 27.1413 25.7074 27.2383 25.2564 27.4196Z",
    fill: "#69C9D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.272 22.547H28.6442V30.8317C28.6442 31.123 28.6442 31.4038 28.5432 31.6844C28.3788 32.1321 28.0291 32.5365 27.563 32.7159C26.8633 32.9853 26.3164 32.9554 25.6639 32.5422C25.5019 32.4353 25.3595 32.3035 25.2423 32.1522C25.7982 32.4364 26.2958 32.4314 26.9122 32.1943C27.378 32.0149 27.7282 31.6105 27.8921 31.1625C27.9947 30.8827 27.9933 30.6011 27.9933 30.3101V22.0238H30.2411C30.2411 22.0238 30.2158 22.2297 30.272 22.547ZM33.3502 25.0193V25.4804C33.0863 25.4201 32.8305 25.331 32.5878 25.2149C32.1177 24.9899 31.7514 24.6236 31.6798 24.5495C31.7629 24.6018 31.8491 24.6493 31.9381 24.692C32.5097 24.9655 33.0727 25.0471 33.3502 25.0193Z",
    fill: "#69C9D0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2245 30.4201C24.3026 29.7732 24.568 29.411 25.068 29.0396C25.7834 28.5367 26.6771 28.8212 26.6771 28.8212V27.1336C26.8944 27.1281 27.1117 27.141 27.3266 27.1721V29.3439C27.3266 29.3439 26.4332 29.0594 25.7178 29.5626C25.218 29.9336 24.9521 30.2961 24.8743 30.943C24.8718 31.2943 24.9378 31.7535 25.2413 32.1506C25.1663 32.1121 25.0898 32.0683 25.0118 32.019C24.3431 31.57 24.2212 30.8962 24.2245 30.4201ZM31.0166 24.0133C30.5245 23.474 30.3383 22.9295 30.2711 22.547H30.8902C30.8902 22.547 30.7667 23.5499 31.6664 24.5362L31.6789 24.5495C31.4364 24.397 31.214 24.2169 31.0166 24.0133ZM33.999 25.5423V27.6703C33.999 27.6703 33.209 27.6394 32.6243 27.4906C31.808 27.2826 31.2833 26.9636 31.2833 26.9636C31.2833 26.9636 30.9208 26.736 30.8915 26.7202V31.1147C30.8915 31.3593 30.8245 31.9704 30.6202 32.4801C30.3535 33.1468 29.942 33.5844 29.8663 33.6739C29.8663 33.6739 29.3657 34.2654 28.4826 34.6638C27.6866 35.0231 26.9877 35.014 26.7788 35.0231C26.7788 35.0231 25.5707 35.071 24.4836 34.3645C24.2485 34.2088 24.0291 34.0324 23.8281 33.8377L23.8336 33.8416C24.9209 34.5481 26.1288 34.5002 26.1288 34.5002C26.338 34.4911 27.0368 34.5002 27.8326 34.1409C28.7149 33.7425 29.2162 33.1509 29.2162 33.1509C29.2911 33.0615 29.7046 32.6239 29.9702 31.9569C30.1739 31.4475 30.2415 30.8362 30.2415 30.5915V26.1975C30.2708 26.2137 30.633 26.4412 30.633 26.4412C30.633 26.4412 31.158 26.7605 31.9743 26.9683C32.5592 27.117 33.349 27.1479 33.349 27.1479V25.4804C33.6192 25.541 33.8496 25.5573 33.999 25.5423Z",
    fill: "#EE1D52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3502 25.4804V27.1474C33.3502 27.1474 32.5604 27.1165 31.9755 26.9677C31.1592 26.7597 30.6342 26.4407 30.6342 26.4407C30.6342 26.4407 30.272 26.2131 30.2427 26.197V30.592C30.2427 30.8367 30.1757 31.448 29.9714 31.9574C29.7047 32.6244 29.2931 33.062 29.2174 33.1515C29.2174 33.1515 28.7166 33.743 27.8338 34.1414C27.0381 34.5007 26.3392 34.4916 26.13 34.5007C26.13 34.5007 24.9222 34.5486 23.8348 33.8421L23.8293 33.8382C23.7145 33.727 23.6065 33.6096 23.5057 33.4866C23.1587 33.0636 22.946 32.5633 22.8925 32.4205C22.8924 32.4199 22.8924 32.4193 22.8925 32.4187C22.8065 32.1706 22.6258 31.5749 22.6505 30.9979C22.6942 29.9799 23.0523 29.355 23.147 29.1985C23.3978 28.7716 23.7239 28.3897 24.111 28.0697C24.4525 27.7936 24.8396 27.5739 25.2564 27.4197C25.707 27.2385 26.1895 27.1415 26.678 27.1336V28.8212C26.678 28.8212 25.7844 28.5378 25.0692 29.0396C24.5692 29.411 24.3038 29.7732 24.2257 30.4201C24.2225 30.8962 24.3443 31.57 25.0125 32.0193C25.0904 32.0687 25.167 32.1126 25.242 32.1509C25.3588 32.3026 25.5008 32.4348 25.6625 32.5422C26.3153 32.9554 26.8622 32.9843 27.5617 32.7159C28.028 32.5365 28.3791 32.1321 28.5419 31.6841C28.6442 31.4043 28.6428 31.1227 28.6428 30.8315V22.547H30.2706C30.3379 22.9295 30.524 23.474 31.0162 24.0133C31.2136 24.2169 31.436 24.397 31.6784 24.5495C31.7501 24.6236 32.1163 24.99 32.5865 25.2149C32.8296 25.3311 33.0859 25.4202 33.3502 25.4804Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2441 31.9023V31.9036L22.2845 32.0131C22.2799 32.0004 22.2649 31.9616 22.2441 31.9023Z",
    fill: "#69C9D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2564 27.4196C24.8396 27.5739 24.4525 27.7936 24.111 28.0697C23.7238 28.3904 23.3977 28.7731 23.1473 29.2008C23.0526 29.3568 22.6945 29.9822 22.6508 31.0002C22.6261 31.5772 22.8068 32.1729 22.8928 32.421C22.8927 32.4216 22.8927 32.4222 22.8928 32.4228C22.9471 32.5643 23.159 33.0646 23.506 33.4889C23.6067 33.612 23.7148 33.7293 23.8296 33.8405C23.4618 33.5967 23.1337 33.3019 22.8562 32.9658C22.5122 32.5463 22.3 32.0512 22.2447 31.9051C22.2446 31.9041 22.2446 31.903 22.2447 31.902V31.9002C22.1584 31.6524 21.9772 31.0564 22.0024 30.4786C22.0461 29.4606 22.4042 28.8357 22.4989 28.6792C22.7493 28.2515 23.0753 27.8687 23.4625 27.5481C23.804 27.2719 24.1911 27.0522 24.608 26.898C24.868 26.7946 25.1389 26.7183 25.4159 26.6705C25.8335 26.6006 26.2599 26.5946 26.6794 26.6525V27.1336C26.1904 27.1413 25.7074 27.2383 25.2564 27.4196Z",
    fill: "#69C9D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.272 22.547H28.6442V30.8317C28.6442 31.123 28.6442 31.4038 28.5432 31.6844C28.3788 32.1321 28.0291 32.5365 27.563 32.7159C26.8633 32.9853 26.3164 32.9554 25.6639 32.5422C25.5019 32.4353 25.3595 32.3035 25.2423 32.1522C25.7982 32.4364 26.2958 32.4314 26.9122 32.1943C27.378 32.0149 27.7282 31.6105 27.8921 31.1625C27.9947 30.8827 27.9933 30.6011 27.9933 30.3101V22.0238H30.2411C30.2411 22.0238 30.2158 22.2297 30.272 22.547ZM33.3502 25.0193V25.4804C33.0863 25.4201 32.8305 25.331 32.5878 25.2149C32.1177 24.9899 31.7514 24.6236 31.6798 24.5495C31.7629 24.6018 31.8491 24.6493 31.9381 24.692C32.5097 24.9655 33.0727 25.0471 33.3502 25.0193Z",
    fill: "#69C9D0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_70)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 38.0238,
    rx: 11.5,
    ry: 6.5,
    fill: "#ED2256"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 12.6238,
    width: 31.8,
    height: 31.8,
    rx: 15.9,
    stroke: "url(#paint0_radial_0_70)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter3_f_0_70)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29.5238,
    r: 9,
    fill: "white",
    fillOpacity: 0.18
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_70",
    x: 2,
    y: 2.5238,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_70",
    x: 8,
    y: 8.5238,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_0_70"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_70",
    x: 0,
    y: 13.5238,
    width: 59,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_0_70"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_70",
    x: 0,
    y: 0.523804,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_0_70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_70",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2878 13.4759) rotate(44.0741) scale(43.4569 69.503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_70"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.b717abcb785fed46fd23bfbb05ad7afb.svg";
export { ForwardRef as ReactComponent };